export default function ($http) {
    return function (userId) {
        return $http({
            method: 'DELETE',
            url: `/api/users/delete/${ userId }`
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/services/delete/deleteUser.js